export const PENDING = 'PENDING';
export const REJECTED = 'REJECTED';
export const FULFILLED = 'FULFILLED';
